export default "__VITE_ASSET__CsqCABHo__"